import React from "react";
import { graphql, useFragment } from "react-relay";

import type { contentSummaryContent$key } from "shared/queries/__generated__/contentSummaryContent.graphql";

import { H2Container, H3Container } from "./styles";

export type Props = {
  className?: string;
  componentTag?: "h2" | "h3";
  isTextOverflowEllipsis?: boolean;
  reference: contentSummaryContent$key;
};

export const ContentSummary: React.FunctionComponent<Props> = ({
  componentTag = "h2",
  isTextOverflowEllipsis,
  reference,
  ...attributes
}) => {
  const content = useFragment(
    graphql`
      fragment contentSummaryContent on Content {
        __typename
        summary {
          text
        }
      }
    `,
    reference,
  );

  const isVideo = content?.__typename === "Video";

  const isEnableTextOverflowEllipsis = (isTextOverflowEllipsis && isVideo) ?? false;

  if (!content.summary?.text?.trim()) return null;
  const ContainerWithTag = componentTag === "h2" ? H2Container : H3Container;
  return (
    <ContainerWithTag $isEnableTextOverflowEllipsis={isEnableTextOverflowEllipsis} {...attributes}>
      {content.summary?.text ?? ""}
    </ContainerWithTag>
  );
};

ContentSummary.displayName = "ContentSummary";
